import { useEffect, useState } from "react";
import {
  getConsent,
  subscribeConsent,
} from "../lib/cookie-consent";

const GA4_ID = "G-T0P20ZXJ8B";
const CLARITY_ID = "wwj7dqshfw";
const LEADINFO_ID = "LI-65099619B4E0D";

/**
 * Injectes 3rd-party tracking scripts only after the user has given consent.
 * CRA port of components/TrackingScripts.tsx (no next/script).
 *
 * GA4 → consent.statistics
 * Microsoft Clarity → consent.statistics
 * LeadInfo → consent.marketing
 */
const TrackingScripts = () => {
  const [consent, setConsentState] = useState(null);

  useEffect(() => {
    setConsentState(getConsent());
    const unsubscribe = subscribeConsent(setConsentState);
    return unsubscribe;
  }, []);

  // GA4 + Microsoft Clarity (statistica)
  useEffect(() => {
    if (!consent?.statistics) return;
    if (window.__onsportsGa4Loaded) return;
    window.__onsportsGa4Loaded = true;

    // GA4 loader
    const loader = document.createElement("script");
    loader.async = true;
    loader.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(loader);

    // GA4 init
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA4_ID, {
      page_path: window.location.pathname,
      anonymize_ip: true,
    });

    // Microsoft Clarity
    (function (c, l, a, r, i) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      const t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      const y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_ID);
  }, [consent?.statistics]);

  // LeadInfo (marketing)
  useEffect(() => {
    if (!consent?.marketing) return;
    if (window.__onsportsLeadinfoLoaded) return;
    window.__onsportsLeadinfoLoaded = true;

    (function (l, e, a, d, i, n) {
      if (!l[i]) {
        l.GlobalLeadinfoNamespace = l.GlobalLeadinfoNamespace || [];
        l.GlobalLeadinfoNamespace.push(i);
        l[i] = function () {
          (l[i].q = l[i].q || []).push(arguments);
        };
        l[i].t = l[i].t || n;
        l[i].q = l[i].q || [];
        const o = e.createElement(a);
        const f = e.getElementsByTagName(a)[0];
        o.async = 1;
        o.src = d;
        f.parentNode.insertBefore(o, f);
      }
    })(
      window,
      document,
      "script",
      "https://cdn.leadinfo.net/ping.js",
      "leadinfo",
      LEADINFO_ID
    );
  }, [consent?.marketing]);

  return null;
};

export default TrackingScripts;
